var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',{attrs:{"disabled":_vm.disabled,"icon":"","plain":""},on:{"click":function($event){return _vm.emitClickEvent(_vm.iconKey)}}},[_c('v-icon',_vm._g(_vm._b({},'v-icon',attrs,false),on),[_vm._v(" "+_vm._s(_vm.iconValue)+" ")])],1)]}}])},[_c('span',[_vm._v(" "+_vm._s(_vm.iconText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }